import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CtaSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="relative bg-[#1A1A1A] py-24 md:py-36 px-6 md:px-10 lg:px-16 overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e6d28648db512e99950620f21932bd0a.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-[#1A1A1A]/70" />
      </div>

      <div ref={ref} className="relative z-10 max-w-3xl mx-auto text-center">
        <div
          className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-8 h-px bg-gray-600" />
            <span
              className="text-xs tracking-widest uppercase text-gray-400"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Parlons de votre projet
            </span>
            <div className="w-8 h-px bg-gray-600" />
          </div>

          <h2
            className="text-white mb-6"
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontWeight: 300,
              fontSize: 'clamp(36px, 5vw, 68px)',
              lineHeight: '1.1',
              letterSpacing: '-0.01em',
            }}
          >
            Contactez-nous pour<br />
            discuter de votre <em style={{ fontStyle: 'italic' }}>projet</em>
          </h2>

          <p
            className="text-gray-400 mb-12 max-w-md mx-auto text-base leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Décrivez-nous votre besoin en design créatif et nous vous répondrons rapidement pour construire ensemble une solution adaptée.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-10 py-4 bg-white text-[#1A1A1A] text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer hover:bg-gray-100 transition-colors duration-200 rounded-sm"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 500 }}
            >
              Nous contacter
              <i className="ri-arrow-right-line text-base" />
            </Link>
            <a
              href="mailto:joannawab1ch@outlook.com"
              className="inline-flex items-center justify-center gap-2 px-10 py-4 border border-gray-600 text-gray-300 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer hover:border-gray-300 hover:text-white transition-colors duration-200 rounded-sm"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400 }}
            >
              <i className="ri-mail-line text-base" />
              Écrire un email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
